import createStore from 'fluxible/addons/createStore';

export default createStore({
    storeName: 'DesignSketchesStore',

    handlers: {
        SET_DESIGN_SKETCH_STATE: 'setDesignSketchState',
        SET_DESIGN_SKETCH: 'setDesignSketch',
        ADD_DESIGN_PATH: 'addDesignPath',
        UNDO_LAST_DESIGN_PATH: 'undoLastDesignPath',
    },

    initialize: function() {
        this.designs = {};
    },

    setDesignSketch: function({ designId, sketch }) {
        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = {
            ...this.designs,
            [designId]: {
                ...this.designs[designId],
                sketch,
            },
        };
        this.emitChange();
    },

    getDesignSketch: function(designId) {
        return this.designs[designId] ? this.designs[designId].sketch : [];
    },

    getPathsFromDesignSketch: function(designId) {
        const sketch = this.getDesignSketch(designId);
        return sketch.map(pathObj => pathObj.path);
    },

    addDesignPath: function({ designId, path }) {
        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = {
            ...this.designs,
            [designId]: {
                ...this.designs[designId],
                sketch: [...this.designs[designId].sketch, { path: path }],
            },
        };

        this.emitChange();
    },

    undoLastDesignPath: function({ designId }) {
        if (this.designs[designId]) {
            this.designs = {
                ...this.designs,
                [designId]: {
                    ...this.designs[designId],
                    sketch: this.designs[designId].sketch.slice(0, -1),
                },
            };
            this.emitChange();
        }
    },

    setDesignSketchState: function({ state, designId }) {
        this.designs[designId] = this.designs[designId] || { sketch: [], state: null };

        this.designs = {
            ...this.designs,
            [designId]: {
                ...this.designs[designId],
                state,
            },
        };
        this.emitChange();
    },

    getDesignSketchState: function(designId) {
        return this.designs[designId] ? this.designs[designId].state : null;
    },
});



// WEBPACK FOOTER //
// ./~/@99designs/ddo/stores/DesignSketchesStore.js